<template>
  <div class="choices">
    <p class="choices-title">ブランドを選択</p>
    <div class="choices-buttons">
      <button
        v-for="(brand, index) in myBrandList"
        :key="brand.text"
        class="choices-button"
        :class="{'is-selected': brand.selected}"
        @click="selectBrand(index)"
      >
        <span class="choices-button-icon" />
        <span class="choices-button-text" v-text="brand.text" />
      </button>
    </div>

    <p class="choices-title">肌のお悩みについて気になることを選択</p>
    <div class="choices-buttons choice-mb0">
      <button
        v-for="(select1, index) in mySelectList1"
        :key="select1.index"
        class="choices-button"
        :class="{'is-selected': select1.selected}"
        @click="selectChoice1(select1.id, index)"
      >
        <span class="choices-button-icon" />
        <span class="choices-button-text" v-text="select1.text" />
      </button>
    </div>

    <button class="choices-search" @click="goSearch">
      <svg id="グループ_1008" data-name="グループ 1008" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="14" height="14" viewBox="0 0 14 14">
        <defs>
          <clipPath id="clip-path">
            <rect id="長方形_143" data-name="長方形 143" width="14" height="14" transform="translate(0 0)" fill="#fff"/>
          </clipPath>
        </defs>
        <g id="グループ_1007" data-name="グループ 1007" clip-path="url(#clip-path)">
          <path id="パス_86" data-name="パス 86" d="M13.473,12.7,10.5,9.727A5.987,5.987,0,1,0,9.38,10.761L12.4,13.777A.761.761,0,1,0,13.473,12.7M1.522,5.935a4.413,4.413,0,1,1,4.413,4.413A4.418,4.418,0,0,1,1.522,5.935" fill="#fff"/>
        </g>
      </svg>
      <span>検索する</span>
    </button>
  </div>
</template>

<script>
// import { WORRIES, SKIN_TYPE, MAKE_FREQUENCY, AGE } from '@/config/sortConditions.js';
export default {
  name: 'SortResultSortChoices',
  data: () => {
    return {
      flagFirst: false,
      brands: [],
      status: {
        skin: null,
        worriesome: [],
        make: null,
        age: null
      },
      myBrandList: null,
      mySelectList1: null,
      mySelectList2: null,
      mySelectList3: null,
      mySelectList4: null
    };
  },
  props: {
    brandList: {
      type: Array
    },
    skincareList: {
      type: Array
    },
    baseList: {
      type: Array
    },
    selectList1: {
      type: Array
    },
    selectList2: {
      type: Array
    },
    selectList3: {
      type: Array
    },
    selectList4: {
      type: Array
    }
  },
  methods: {
    /**
     * 選択肢を押す
     */
    selectBrand(index) {
      // 最初にmasterを格納する
      this.setStatus();
      // チェックボックスの操作
      if (this.brands.indexOf(index) !== -1 ) {        
        const _index = this.brands.indexOf(index);
        this.brands.splice(_index, 1);
        this.myBrandList[index].selected = false;
      } else {
        this.brands.push(index);
        this.myBrandList[index].selected = true;
      }
    },
    selectChoice1(id, index) {
      // 最初にmasterを格納する
      this.setStatus();
      // チェックボックスの操作
      if (this.status.worriesome.indexOf(id) !== -1 ) {        
        const _index = this.status.worriesome.indexOf(id);
        this.status.worriesome.splice(_index, 1);
        this.mySelectList1[index].selected = false;
      } else {
        this.status.worriesome.push(id);
        this.mySelectList1[index].selected = true;
      }
    },
    /**
     * 検索ボタンで検索する
     */
    goSearch() {
      // 最初にmasterを格納する
      this.setStatus();
      // ブランドの操作
      this.brands.forEach(index => {
        this.$emit('clickedSort', index, 'brand');
      });
      // ブランドのemit後消えるselectedを上書き
      this.brands.forEach(index => {
        this.myBrandList[index].selected = true;
      });      
      this.$emit('sortChoices', this.status);
    },
    /**
     * 最初の初期値をセットする
     */
    setStatus() {
      if (this.flagFirst === false) {
        this.mySelectList1.forEach(item => {
          if (item.selected === true) {
            this.status.worriesome.push(item.id);
          }
        });
        this.mySelectList2.forEach(item => {
          if (item.selected === true) {
            this.status.skin = item.id;
          }
        });
        this.mySelectList3.forEach(item => {
          if (item.selected === true) {
            this.status.make = item.id;
          }
        });
        this.mySelectList4.forEach(item => {
          if (item.selected === true) {
            this.status.age = item.id;
          }
        });
        this.flagFirst = true;
      }
    }
  },
  mounted() {
    this.myBrandList = this.brandList;
    this.mySelectList1 = this.selectList1;
    this.mySelectList2 = this.selectList2;
    this.mySelectList3 = this.selectList3;
    this.mySelectList4 = this.selectList4;
  }
}
</script>

<style lang="scss" scoped>
.choices {
  text-align: left;
  &-title {
    width: 295/375 * 100%;
    margin: 30/375 * 100% auto 0;
    padding-bottom: 15/375 * 100%;
    border-bottom: 1px solid #333;
    font-size: 12/375 * 100vw;
    font-weight: bold;
    @include media() {
      max-width: 800px;
      margin: 32px auto 0;
      padding-bottom: 15px;
      font-size: 13px;
    }
  }
  &-buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 295/375 * 100%;
    margin: 13/375 * 100% auto 0;
    @include media() {
      max-width: 800px;
      margin: 5px auto 30px;
      justify-content: flex-start;
    }
  }
  &-button {
    text-align: left;
    display: flex;
    align-items: baseline;
    justify-content: flex-start;
    width: 140/295 * 100%;
    margin: 7/295 * 100% 0;
    @include media() {
      width: auto;
      margin: 15px 20px 0 0;
      cursor: pointer;
    }
    &-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      // width: 11/375 * 100vw;
      // height: 11/375 * 100vw;
      border: 1px solid #333;
      // margin-right: 5/375 * 100vw;
      width: 15px;
      height: 15px;
      margin-right: 5px;
      position: relative;
      transform: translateY(3px);
      @include media() {
        width: 11px;
        height: 11px;
        margin-right: 5px;
      }
      &::before {
        content: '';
        display: block;
        position: absolute;
        top: 2px;
        left: 2px;
        // width: 7/375 * 100vw;
        // height: 7/375 * 100vw;
        width: 11px;
        height: 11px;
        @include media() {
          width: 7px;
          height: 7px;
          transition: .3s ease;
        }
        .is-selected & {
          background: #DF0068;
        }
      }
    }
    &-text {
      width: 120/140 * 100%;
      font-size: 11/375 * 100vw;
      line-height: (14/11);
      @include media() {
        width: auto;
        font-size: 12px;
      }
    }
  }
}
.choice-mb0 {
  margin-bottom: 5px;
}
.choices-search {
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 40px;
  background: #DF0168;
  border: 1px solid #DF0168;
  margin: 20px auto 0;
  padding: 20px 0;
  border-radius: 40px;
  color: #fff;
  cursor: pointer;
  & > span {
    margin-left: 6px;
    transition: .45s ease;
  }
  &:hover > span {
    letter-spacing: .3em;
  }
}
</style>